import type { FaireProductEntity } from "../../entity_types/product";

export const p_yzk3j9au6v: FaireProductEntity = {
  token: "p_yzk3j9au6v",
  type: "product",
  name: "Lady Crackers",
  brandToken: "b_jqejnb29sd",
  brandName: "Lady & Larder",
  imageUrl: "https://cdn.faire.com/fastly/d4910bb34663d3579d3b11179bb393f7e0dd925274cb7df5c164608097ac5950.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/167379fc8083520ad24262de8f23bed0f467dec0e02fb86f558fecdf57493193.png",
    "https://cdn.faire.com/fastly/5e64f0eefd48f262d87c67adbbdec7054aa418e03df721d0a780d1430525d878.png"
  ],
  priceDollars: 4.75,
  description: " sea salt + olive oil sourdough flatbread crackers\n\nperfect amount of crunch. \n\nfriends with all your favorite cheeses and dips.\n\n\n12 boxes per case \n\nEach box is 4 oz (112g)\n\nMade with Love in Marin, California ",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:20.296Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
